import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("monarch_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const submitLead = (payload) => api.post("/leads", payload).then((r) => r.data);
export const submitContact = (payload) => api.post("/contacts", payload).then((r) => r.data);

export const adminLogin = async (email, password) => {
  const { data } = await api.post("/auth/login", { email, password });
  localStorage.setItem("monarch_token", data.access_token);
  localStorage.setItem("monarch_admin_email", data.email);
  return data;
};

export const adminLogout = () => {
  localStorage.removeItem("monarch_token");
  localStorage.removeItem("monarch_admin_email");
};

export const adminMe = () => api.get("/auth/me").then((r) => r.data);
export const adminLeads = () => api.get("/admin/leads").then((r) => r.data);
export const adminContacts = () => api.get("/admin/contacts").then((r) => r.data);
export const adminStats = () => api.get("/admin/stats").then((r) => r.data);
export const updateLeadStatus = (id, status) =>
  api.patch(`/admin/leads/${id}`, { status }).then((r) => r.data);
export const deleteLead = (id) => api.delete(`/admin/leads/${id}`).then((r) => r.data);
export const deleteContact = (id) => api.delete(`/admin/contacts/${id}`).then((r) => r.data);

// Projects
export const listProjects = () => api.get("/projects").then((r) => r.data);
export const createProject = (formData, onProgress) =>
  api
    .post("/admin/projects", formData, {
      headers: { "Content-Type": "multipart/form-data" },
      onUploadProgress: (e) => {
        if (onProgress && e.total) onProgress(Math.round((e.loaded * 100) / e.total));
      },
      timeout: 600000,
    })
    .then((r) => r.data);
export const deleteProject = (id) => api.delete(`/admin/projects/${id}`).then((r) => r.data);
export const updateProject = (id, payload) => api.patch(`/admin/projects/${id}`, payload).then((r) => r.data);
export const fileUrl = (urlOrPath) => {
  if (!urlOrPath) return "";
  if (urlOrPath.startsWith("http")) return urlOrPath;
  if (urlOrPath.startsWith("/api/")) return `${BACKEND_URL}${urlOrPath}`;
  return `${API}/files/${urlOrPath}`;
};
